// import Mousetrap from 'mousetrap';
// import 'lite-youtube-embed';
// import 'lite-youtube-embed/src/lite-yt-embed.css';
 
import { createRenderer } from './renderer';
import { modeManager } from './manager';
import { Playlist } from './playlist';
 
import { RippleMode } from './modes/ripple';
import { RippleBeatMode } from './modes/ripple-beat';
import { WaveMode } from './modes/wave';
import { WaterfallMode } from './modes/waterfall';
import { BreakoutMode } from './modes/breakout';
import { RectangleMode } from './modes/rectangle';
import { PulseMode } from './modes/pulse';
import { StacksMode } from './modes/stacks';
import { PressMode } from './modes/press';
import { SpriteMode } from './modes/sprite';
import { LaunchMode } from './modes/launch';
import { LetterMode } from './modes/letter';
import { CountdownMode, timeToTarget } from './modes/countdown';
import { TennisMode } from './modes/tennis';
 
import { SPRITES } from './sprites';
 
import { forEachCell } from './utils';
 
import progressData from './progress.json';
 
const MODE_LIST = [
  [SpriteMode, 16, {sprite: SPRITES.eye, animationData: {
    delay: {
      0: 10
    },
    color: {
      4: 'orange'
    }
  }}],
  [StacksMode, 32, {up: true}],
  [LetterMode, 32],
  [WaveMode, 32],
  [SpriteMode, 4, {sprite: SPRITES.player1}],
  [RippleBeatMode, 32],
  [BreakoutMode, 64],
  [SpriteMode, 4, {sprite: SPRITES.shapes}],
  [SpriteMode, 4, {sprite: SPRITES.player2}],
  [LetterMode, 32],
  [SpriteMode, 8, {sprite: SPRITES.blocktypes, animationData: {
    delay: {
      0: 4,
      2: 4,
      3: 4,
      4: 4
    }
  }}],
  [TennisMode, 64],
  [SpriteMode, 4, {sprite: SPRITES.globe}],
  [StacksMode, 32, {up: false}],
  [WaveMode, 32],
  [SpriteMode, 4, {sprite: SPRITES.warp}],
  [LetterMode, 32],
  [StacksMode, 32, {up: false}],
];
 
document.addEventListener("DOMContentLoaded", function(event) {
 
  // var stats = new Stats();
  // stats.showPanel( 0 );
 
  const overlayCloseArea = document.querySelector('.overlay-close-area');
  const overlayContent = document.querySelector('.overlay-content');
 
  const countdownEl = document.querySelector('.countdown');
  let countdownTotalTime = 0;
  function updateCountdown(delta) {
    const name = 'C-SMASH VRS';
    const visible = name.slice(0, countdownTotalTime / 120);
    const hidden = name.slice(countdownTotalTime / 120);
    countdownEl.innerHTML = `${visible}<span style="opacity: 0">${hidden}</span>`;
    countdownTotalTime += delta;
  }
 
  let overlayVisible = false;
  const setOverlay = visible => {
    overlayVisible = visible;
    document.querySelector('body').classList.toggle('show-overlay', overlayVisible);
    if (overlayVisible) {
      manager.toggleMute(false);
    }
  }
  document.querySelector('.dots').addEventListener('click', (event) => {
    if (!overlayVisible) {
      launchApp();
    }
  })
  overlayCloseArea.addEventListener('click', (event) => {
    if (overlayVisible) {
      setOverlay(false);
    }
  })
 
  overlayCloseArea.addEventListener('click', (event) => {
    if (overlayVisible) {
      setOverlay(false);
    } else {
      launchApp();
    }
  })
  overlayContent?.addEventListener('click', (event) => {
    setOverlay(true);
  })
  if (overlayContent) {
    document.addEventListener("scroll", (event) => {
      const scrollTrigger = window.innerWidth < 500 ? window.innerHeight / 8 : window.innerHeight / 4;
      if (window.scrollY > scrollTrigger && !overlayVisible) {
        setOverlay(true);
        document.body.scrollBy({
          left: 0,
          top: - (window.innerHeight - 100 + 200),
          behavior: 'smooth'
        });
      }
    });
  }
 
  const {addInteractionListener, removeInteractionListener, removeAllInteractionListeners, render, showDots} = createRenderer();
  const manager = modeManager({addInteractionListener, removeInteractionListener });
   
  const playlist = new Playlist({ manager, modes: MODE_LIST, removeAllInteractionListeners });
 
  manager.layer(0).switchTo(LaunchMode)
  manager.layer(1).switchTo(RippleMode, {muted: true})
 
  // Mousetrap.bind('s', playlist.skip);
 
  const muteToggleButton = document.querySelector('.unmute');
 
  let appLaunched = false;
  function launchApp() {
    if (!appLaunched) {
      manager.toggleMute(true);
      muteToggleButton.classList.add('visible');
      document.body.removeEventListener('click', launchApp);
      appLaunched = true;
    }
  }
 
  muteToggleButton.addEventListener('click', () => {
    const isMuted = manager.toggleMute();
    muteToggleButton.classList.toggle('muted', isMuted);
  });
 
  let dotMatrixActivated = false;
 
  let prevTime = null;
  function update(time) {
    let delta = 0;
    if (time && prevTime) {
      delta = time - prevTime
    }
    prevTime = time;

    updateCountdown(delta);
 
    if (dotMatrixActivated) {
      playlist.update(manager.getCurrentTime());
      manager.update(delta);
      const data = manager.getData();
      render(data, delta);
    }
 
 
    window.requestAnimationFrame(update);
  }
 
  updateCountdown(0);
  update();
   
  setTimeout(() => {
    countdownEl.classList.add('shrunk')
  }, 2000);
  setTimeout(() => {
    showDots();
  }, 2500);
  setTimeout(() => {
    dotMatrixActivated = true;
  }, 3000);
 
  const socialIcons = Array.from(document.querySelectorAll('.social-icons li'));
  socialIcons.forEach((el,i) => {
    setTimeout(() => {
      el.classList.add('visible')
    }, 2000 + (i * 50));  
  });
});